import { PathParam } from 'react-router-dom';
import { AppLink, AppLinkProps } from '../common/AppLink';
import { UiPath } from './index';
import { QueryParams, UiPathParams, withParams } from './withParams';

/**
 * Requires params only if the given path has parameter tokens in it.
 */
export type UiLinkProps<Path extends UiPath> = Omit<AppLinkProps, 'to'> &
  (PathParam<Path> extends never
    ? {
        path: Path;
        params?: Partial<QueryParams>;
      }
    : {
        path: Path;
        params: UiPathParams<Path> & Partial<QueryParams>;
      });

export const UiLink = <Path extends UiPath>(props: UiLinkProps<Path>) => {
  if ('params' in props && props.params) {
    const { path, params, ...rest } = props;
    return <AppLink to={withParams(path, params as any)} {...rest} />;
  }

  const { path, ...rest } = props;
  return <AppLink to={path} {...rest} />;
};
